import { render, staticRenderFns } from "./RequestFiles.vue?vue&type=template&id=61d546bd&"
import script from "./RequestFiles.vue?vue&type=script&lang=js&"
export * from "./RequestFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports